import React, { Component } from 'react';
import styled from 'styled-components';

export default class LeftMenuButton extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const imgSrc = this.props.valid ? '/images/redesign/navbar/next.png' : '/images/redesign/navbar/next-invalid.png';
    return (
      <div style={{ backgroundColor: 'none', width: 75, height: 75 }} onClick={this.props.onClick}>
        <Image src={imgSrc} />
      </div>
    );
  }
}

const Image = styled.img`
	display: block;
	height: auto;
  width: 100%;
`;



// WEBPACK FOOTER //
// ./client/redesign/signup/Main/Navbar/RightNextButton/index.js